var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"rules":_vm.rules,"type":_vm.type,"value":_vm.value,"required":_vm.required,"readonly":_vm.readonly,"outlined":"","dense":""},on:{"input":_vm.sendToParent},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }